import { render, staticRenderFns } from "./modalDetallePago.vue?vue&type=template&id=7b2ea70e&scoped=true"
import script from "./modalDetallePago.vue?vue&type=script&lang=js"
export * from "./modalDetallePago.vue?vue&type=script&lang=js"
import style0 from "./modalDetallePago.vue?vue&type=style&index=0&id=7b2ea70e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2ea70e",
  null
  
)

export default component.exports